import * as React from "react";

const Line = (props: { color?: string; strokeWidth?: number }): JSX.Element => (
    <svg width="15" height="2" viewBox="0 0 15 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line
            x1="0.75"
            y1="0.75"
            x2="14.25"
            y2="0.75"
            stroke={props.color ?? "#646262"}
            strokeWidth={props.strokeWidth ?? 1.5}
            strokeLinecap="round"
        />
    </svg>
);

export default Line;
